import { useNavigate } from "@solidjs/router";
import { BigNumber } from "bignumber.js";
import log from "loglevel";
import {
    BiRegularCopy,
    BiRegularDownload,
    BiRegularTrash,
} from "solid-icons/bi";
import { IoCheckmark } from "solid-icons/io";
import { Show, createSignal } from "solid-js";

import { copyIconTimeout } from "../../consts/CopyContent";
import { useCreateContext } from "../../context/Create";
import { useGlobalContext } from "../../context/Global";
import { downloadRescueFile } from "../../utils/backup";
import { clipboard } from "../../utils/helper";
import { generateRescueFile } from "../../utils/rescueFile";

const RescueFile = () => {
    const iconSize = 16;
    const navigate = useNavigate();

    const {
        rescueFile,
        t,
        setRescueFile,
        clearSwaps,
        setRescueFileBackupDone,
        setSettingsMenu,
        notify,
        setLastUsedKey,
    } = useGlobalContext();
    const { setSendAmount, setReceiveAmount } = useCreateContext();

    const [copied, setCopied] = createSignal(false);

    const copy = () => {
        const file = rescueFile();
        if (file === null) {
            return;
        }
        clipboard(file.mnemonic);
        setCopied(true);
        setTimeout(() => setCopied(false), copyIconTimeout);
    };

    const handleReset = async () => {
        const confirmText = window.prompt(t("reset_rescue_key_prompt"));

        if (confirmText === null) {
            // User clicked Cancel
            return;
        }

        if (confirmText.toLowerCase() !== "confirm") {
            alert(t("reset_rescue_key_invalid_confirmation"));
            return;
        }

        try {
            await clearSwaps();
            const newRescueFile = generateRescueFile();
            setRescueFile(newRescueFile);
            setLastUsedKey(0);
            setRescueFileBackupDone(false);
            setSettingsMenu(false);
            setSendAmount(BigNumber(0));
            setReceiveAmount(BigNumber(0));
            navigate("/");
            log.info("New Rescue Key generated by user");
            notify("success", t("reset_rescue_key_success"));
        } catch (error) {
            alert(t("reset_rescue_key_error", { error }));
            log.error("Failed to reset rescue key", error);
        }
    };

    return (
        <div class="flex" data-testid="rescue-key-download">
            <span class="btn-small" onClick={copy}>
                <Show
                    when={copied()}
                    fallback={<BiRegularCopy size={iconSize} />}>
                    <IoCheckmark size={iconSize} />
                </Show>
            </span>
            &nbsp;
            <span
                class="btn-small"
                onClick={() => downloadRescueFile(rescueFile)}>
                <BiRegularDownload size={iconSize} />
            </span>
            &nbsp;
            <span
                class="btn-small btn-danger"
                data-testid="reset-rescue-key"
                onClick={handleReset}>
                <BiRegularTrash size={iconSize} />
            </span>
        </div>
    );
};

export default RescueFile;
